import Base from './Base';

const Add = Base('M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z');

export default Add;
